var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationButtonSelected({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 58,
    viewBox: "0 0 65 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22.5,
    cy: 22.5,
    r: 22.5,
    fill: "#002648"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.0877 24.3494C32.2916 22.5839 32.9991 20.427 32.9991 18.0985C32.9991 12.1205 28.3359 7.27441 22.5836 7.27441C16.8312 7.27441 12.168 12.1205 12.168 18.0985C12.168 20.4271 12.8755 22.5839 14.0795 24.3495L22.5836 38.7255L31.0877 24.3494Z",
    fill: "#3CB500"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationButtonSelected);
export default __webpack_public_path__ + "static/media/location-button-selected.94775002f3c100a01669ddd933d3f5a3.svg";
export { ForwardRef as ReactComponent };